__turbopack_context__.v({
  "avatar": "StaffCard-module-scss-module__MLbjaa__avatar",
  "blocksBackgroundColor": "StaffCard-module-scss-module__MLbjaa__blocksBackgroundColor",
  "blocksFontColor": "StaffCard-module-scss-module__MLbjaa__blocksFontColor",
  "container": "StaffCard-module-scss-module__MLbjaa__container",
  "imageContainer": "StaffCard-module-scss-module__MLbjaa__imageContainer",
  "secondaryNavBackgroundColor": "StaffCard-module-scss-module__MLbjaa__secondaryNavBackgroundColor",
  "staffName": "StaffCard-module-scss-module__MLbjaa__staffName",
  "staffTitle": "StaffCard-module-scss-module__MLbjaa__staffTitle",
  "themeBackgroundColor": "StaffCard-module-scss-module__MLbjaa__themeBackgroundColor",
  "themeFontColor": "StaffCard-module-scss-module__MLbjaa__themeFontColor",
  "themeFontFamily": "StaffCard-module-scss-module__MLbjaa__themeFontFamily",
});
